import React, { FC } from 'react';
import './TrainingCard.css';
import { TrainingModule, NavStackItem } from '../../models'
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { actionCreators, State } from '../../state/index'
import { bindActionCreators } from 'redux';
import { useDispatch } from 'react-redux';
import { trainingForModule } from '../LearninHome/LearninHome'

interface TrainingCardProps {
  module: TrainingModule
  small?: boolean
  customClass?: String
}

const TrainingCard: FC<TrainingCardProps> = ({module, small = false, customClass}: TrainingCardProps) => {

  const navigate = useNavigate()
  const { navState } = useSelector((state: State) => state)
  const dispatch = useDispatch()
  const { updateTrainingState, updateNavState } = bindActionCreators(actionCreators, dispatch)

  const cardSelected = () => {
    var path = "/training"
    if (module === TrainingModule.ScanningSutures || module === TrainingModule.OrderManagement || module === TrainingModule.ExpiryManagement) {
      path = "/module"
    }
    var ns = navState.stack
    const nsi: NavStackItem = {
        trainingModule: module,
        path: path
    }
    ns.push(nsi)
    updateNavState({stack: ns})
    updateTrainingState(trainingForModule(module))
    navigate(path)
  }
  
  return (
    <div className={`TrainingCard${customClass ? ` ${customClass}` : ''}`} onClick={cardSelected}>
      <div className={`imageContainer ${module.toLowerCase()}${small ? ' small' : ''}`}></div>
      <div className={`cardTitle${small ? ' small' : ''}`}>{module}</div>
    </div>
)};

export default TrainingCard;
